import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'clients',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError } = slice.actions

export const loadClientsData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const [page, clients] = await Promise.all([
            strapiFetch('/api/clients-page', {
                locale,
                params: {
                    'populate[seo]': 'true',
                    'populate[banner][populate][bannerImage]': 'true',
                },
            }),
            strapiFetch('/api/clients', {
                params: {
                    'populate[logo]': 'true',
                    'populate[category]': 'true',
                    'pagination[pageSize]': 100,
                },
            }),
        ])
        dispatch(setData({ page: page.data, items: clients.data }))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load clients page'))
    } finally {
        dispatch(setLoading(false))
    }
}
